module.exports = __webpack_public_path__ + "static/media/light-footer-logo.aa1966e7.svg";